import {
  makeStyles,
  Snackbar,
} from "@material-ui/core";
// import Files from "react-files";
// import { Add as AddIcon } from "@material-ui/icons";
import React, {  useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import Blob from "blob";
// import FormData from "form-data";
// import { addNewBrand, setBrandNotificationState } from "../reduxSaga/actions";
// import ProductService from "../services/ProductService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import CashRegisterService from "../services/ProductSellBToC/CashRegisterService";

// import {
//   getAllWarehousesManager,

//   addNewRealWarehouse,
// } from "../reduxSaga/actions";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 300,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AddCaisse = ({ setOnAddCashRegister }) => {
  // const dispatch = useDispatch();
  // const brandNotification = useSelector(
  //   (state) => state.staff.brandNotification
  // );

  // const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [name, setName] = useState();
  const [desc, setDesc] = useState();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  // const onChangeName = (event) => {
  //   setName(event.target.value);
  // };

  // const onChangeDesc = (event) => {
  //   setDesc(event.target.value);
  // };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnAddCashRegister(false);
  };

  const onAddCaisse = () => {
    
    CashRegisterService.addCashRegister(getCurrentUserId())
      .then((response) => {
        setOpenAlert(true);
        setTimeout(setOnAddCashRegister(false), 5000);

        setOnAddCashRegister(false);
        setOpen(false);
        window.location.reload(false);
      })
      .catch((e) => {
        console.log("error", e);
      });
  };

  return (
    <>
      <div class="modal fade" id="add-brand">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Ajouter une caisse</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">
                      Voulez-vous vraiment ajouter une caisse
                    </label>
                    {/* <input
                      placeholder="Libellé"
                      onChange={onChangeName}
                      type="text"
                      id="inputName"
                      className="form-control"
                    /> */}
                  </div>
                </div>
              </div>

              {/* <div className="row">
                <div className="form-group col-sm-12">
                  <label htmlFor="inputDescription">Description</label>
                  <textarea
                    placeholder="Saisir..."
                    onChange={onChangeDesc}
                    id="inputDescription"
                    className="form-control"
                    rows={2}
                  />
                </div>
              </div> */}
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button type="button" onClick={onAddCaisse} class="btn btn-light">
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={openAlert}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddCaisse;
